import React from "react";
import { StyleSheet, View, Platform, ScrollView, Text } from "react-native";
import { withApollo } from "@apollo/client/react/hoc";
import SText from "styled42/components/SText";
import S3Image from "screens/common/S3Image";
import SButton from "styled42/components/SButton";
import { TEST_IDS, ACCESSIBILITY_LABEL } from "utils/testIds/index";
import { pushClevertapEvent } from "utils/clevertapEvents";
import SSnackbar from "styled42/components/SSnackbar";
import {
  cleanInput,
  validateNumericEntry,
  isValidMobile
} from "screens/LoginRegistration/utils";
import SClickableArea from "styled42/components/SClickableArea";
import SModal from "styled42/components/SModal";
import SLoader from "styled42/components/SLoader";
import WhatsAppComponent from "screens/LoginRegistration/components/utils/WhatsAppComponent";
import STextField from "styled42/components/STextField";
import { Colors } from "styled42/config";
import { navigate } from "utils/routing/NavRouter";
import SActionCard from "styled42/components/SActionCard";
import LanguagePage from "utils/vernacular/LanguageSetting";
import ArrowNext from "icons/ArrowNext";
import {
  storeDataToAsyncStorage,
  retrieveDataFromAsyncStorage
} from "screens/common/utils";
import VernacManager from "utils/vernacular";
import { onSubmitHandler } from "./utils";
import { getOwnPhoneNumber } from "./phoneUtils";

const TermsAndConditions = (props) => {
  return (
    <View style={styles.termsAndConditionsStyle}>
      <SText size={13} color="#696F7C">
        {`${VernacManager.translateString("new_onboarding_accept_our")} `}
      </SText>
      <SClickableArea
        onClick={() => {
          pushClevertapEvent("loginRegister Clicks", {
            Current_Page: "New loginRegistration",
            Test_Case: props.variant,
            Type: "Privacy Policy"
          });

          if (Platform.OS === "web") {
            navigate("privacyPolicy");
          } else {
            navigate("privacyPolicy", {}, "push", "publicStack");
          }
        }}
      >
        <SText size={13} color="#1b2d93">
          {`${VernacManager.translateString("new_onboarding_privacy_policy")} `}
        </SText>
      </SClickableArea>
      <SText size={13} color="#696F7C">
        {`${VernacManager.translateString("new_onboarding_and")} `}
      </SText>
      <SClickableArea
        onClick={() => {
          pushClevertapEvent("loginRegister Clicks", {
            Current_Page: "New loginRegistration",
            Test_Case: props.variant,
            Type: "Terms of Use"
          });

          if (Platform.OS === "web") {
            navigate("termsPage");
          } else {
            navigate("termsPage", {}, "push", "publicStack");
          }
        }}
      >
        <SText size={13} color="#1b2d93">
          {VernacManager.translateString("new_onboarding_terms_of_use")}
        </SText>
      </SClickableArea>
    </View>
  );
};

class LoginSignUpComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: "",
      enableContinue: false,
      error: null,
      whatsappSubscribed: true,
      snackbarVisible: false,
      snackbarBackgroundColor: "error",
      snackbarText: "",
      loaderVisible: false,
      showLanguagePage: false,
      isCTABusy: false,
      viewKey : Math.random(),
      reLoad:false
    };
    this.typedFirstKeyword = false;
    this.bannerRef = React.createRef();
  }

  componentDidMount = async () => {
    const {
      state: { variant }
    } = this.props;

    const languagePage = await retrieveDataFromAsyncStorage("ShowLanguagePage");
    if (!languagePage) {
      this.setState({ showLanguagePage: true });
    } else if (Platform.OS === "android") {
      this.autoFillPhoneNumber("");
    }

    pushClevertapEvent("Page Load", {
      Current_Page: "New loginRegistration",
      Test_Case: variant,
      Page_Modal: "Welcome - Signup"
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { phoneNumber } = this.state;

    if (
      prevState.phoneNumber === "" &&
      prevState.phoneNumber !== phoneNumber &&
      !this.typedFirstKeyword
    ) {
      const {
        state: { variant }
      } = this.props;
      //  To detect when user has typed the first character
      pushClevertapEvent("Welcome Typing", {
        Page_Modal: "Welcome - Signup",
        Current_Page: "New loginRegistration",
        Test_Case: variant,
        Type: "Phone Number"
      });

      this.typedFirstKeyword = true;
    }
  }

  setPageState = (state) => this.setState(state);

  autoFillPhoneNumber = async (err) => {
    if (Platform.OS === "android") {
      const {
        state: { variant }
      } = this.props;
      pushClevertapEvent("loginRegister Clicks", {
        Type: "Phone_Selector",
        Test_Case: variant
      });
      const phoneNumber = await getOwnPhoneNumber();
      if (phoneNumber) {
        const isValid = this.inputValidation(phoneNumber);
        if (isValid) {
          this.setState({ isCTABusy: true });
          this.loginHandler();
        }
      }
    }
  };

  hideSnackbar = () => {
    this.setState({ snackbarVisible: false });
  };

  setSubscription = (value) => {
    this.setState({ whatsappSubscribed: value });
  };

  inputValidation = (input) => {
    let newState = { ...this.state };

    let isNumeric = false;
    let isValid = false;
    isNumeric = validateNumericEntry(cleanInput("mobile", input));
    if (isNumeric) {
      newState = {
        ...newState,
        phoneNumber: input.length < 11 ? input : newState.phoneNumber
      };

      isValid = isValidMobile(newState.phoneNumber);
      newState = {
        ...newState,
        error: null,
        enableContinue: isValid
      };
      this.setState(newState);
    }
    return isValid;
  };

  setError = (error) => {
    this.setState({ error, isCTABusy: false });
  };

  loginHandler = async () => {
    const { phoneNumber, whatsappSubscribed } = this.state;
    const {
      goNext,
      client,
      state: { variant }
    } = this.props;

    const onboardStartTimeKey = `onboardStartTime_${phoneNumber}`;
    let onboardStartTime = await retrieveDataFromAsyncStorage(
      onboardStartTimeKey
    );
    if (!onboardStartTime) {
      onboardStartTime = new Date().toString();
      await storeDataToAsyncStorage(onboardStartTimeKey, onboardStartTime);
    }

    pushClevertapEvent("loginRegister Clicks", {
      timestamp: onboardStartTime,
      Page_Modal: "Welcome - Signup",
      Test_Case: variant,
      Type: "Number selected"
    });

    await onSubmitHandler({
      phoneNumber,
      whatsappSubscribed,
      setError: this.setError,
      client,
      goNext
    });
  };

  onLayoutChange = (event) => {
    const { x, y, width, height } = event?.nativeEvent?.layout;
    if (height < 550)
      // eslint-disable-next-line no-unused-expressions
      this.bannerRef?.current.setNativeProps({
        transform: [{ scale: 0 }],
        style: { display: "none" }
      });
    // eslint-disable-next-line no-unused-expressions
    else
      this.bannerRef?.current.setNativeProps({
        transform: [{ scale: 1 }],
        style: { display: "flex" }
      });
  };


  onCloseLanguageModal = () => {
    this.setState({ showLanguagePage: false,viewKey:Math.random() },
      () => {
        if (Platform.OS === "android") {
          this.autoFillPhoneNumber("");
        }
          this.setState({viewKey:Math.random(), reLoad:false})
      }
    );

    if (Platform.OS === "android") this.autoFillPhoneNumber("");
  }

  render() {
    const {
      phoneNumber,
      enableContinue,
      error,
      whatsappSubscribed,
      snackbarVisible,
      snackbarBackgroundColor,
      snackbarText,
      loaderVisible,
      isCTABusy,
      showLanguagePage,
      viewKey,
      reLoad
    } = this.state;

    const {
      state: { variant }
    } = this.props;

    if(reLoad){
      return (<View><Text>Reloading</Text></View>);
    }

    return showLanguagePage? (<SActionCard visible={showLanguagePage}>
    <LanguagePage
      profilePage={false}
      onClose={this.onCloseLanguageModal}
    />
  </SActionCard>):(
      <View  key={viewKey} style={styles.root} onLayout={this.onLayoutChange}>

       
        <ScrollView
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{
            flex: 1,
            display: "flex",
            alignItems: "stretch"
          }}
        >
          {/* {Platform.OS === "android" ?
            <S3Image
              path="RocketIntegration"
              name="OnboardingBanner"
              type="png"
              resizeMode="stretch"
              style={styles.banner}
            />
          ) : (
            <S3Image
              path="RocketIntegration"
              name="OnboardingBanner"
              resizeMode="stretch"
              style={styles.banner}
            />
          } */}

          <View style={styles.loginLogoContainer}>
            <S3Image
              name="rocketLogo"
              path="RocketIntegration/onboarding"
              //imageUrl="/static/onboarding/rocketLogo.svg"
              style={styles.logo}
            />

            <View ref={this.bannerRef} style={styles.loginBanner}>
              <S3Image
                name="loginBgCurve"
                path="RocketIntegration/onboarding"
                type="png"
                //imageUrl="/static/onboarding/loginBgCurve.png"
                resizeMode="stretch"
                style={styles.loginCurve}
              />

              <S3Image
                name="avatarOne"
                path="RocketIntegration/onboarding"
                type="png"
                //imageUrl="/static/onboarding/avatarOne.svg"
                style={styles.avatarOne}
              />
              <S3Image
                name="avatarTwo"
                path="RocketIntegration/onboarding"
                type="png"
                //imageUrl="/static/onboarding/avatarTwo.svg"
                style={styles.avatarTwo}
              />
              <S3Image
                name="avatarThree"
                path="RocketIntegration/onboarding"
                type="png"
                //imageUrl="/static/onboarding/avatarThree.svg"
                style={styles.avatarThree}
              />
              {/* <S3Image
                name="Tag"
                path="RocketIntegration/onboarding"
                type="png"
                style={styles.tag}
              /> */}
            </View>
          </View>

          <View style={styles.containerStyle}>
            <SText style={styles.welcomeTxt}>
              {`${VernacManager.translateString(
                "new_onboarding_get_best_jobs"
              )}!`}
              {"\n"}
              <SText style={styles.welcomeTxtNormal}>
                {`${VernacManager.translateString(
                  "new_onboarding_top_companies"
                )}!`}
                {"\n"}
                <SText style={styles.welcomeTxtFree}>
                  {`${VernacManager.translateString("homepage_free")}!`}
                </SText>
              </SText>
            </SText>

            <STextField
              autoFocus
              keyboardType="numeric"
              returnKeyType="done"
              onSubmitEditing={enableContinue ? this.loginHandler : null}
              label=""
              labelStyle={styles.inputLabel}
              placeholder={VernacManager.translateString(
                "new_onboarding_enter_phone"
              )}
              placeholderTextColor={Colors.Grey[5]}
              inputStyle={styles.inputStyle}
              prefix={
                <SText size={18} color={Colors.Grey[5]}>
                  {"  "}
                  +91 -
                </SText>
              }
              error={error}
              value={phoneNumber}
              maxLength={10}
              onChangeText={this.inputValidation}
              testID={TEST_IDS.PHONE_NUMBER_TEXT_FIELD}
              accessibilityLabel={ACCESSIBILITY_LABEL.PHONE_NUMBER_TEXT_FIELD}
            />
          </View>
        </ScrollView>
        <SButton
          text={VernacManager.translateString("new_onboarding_get_otp")}
          suffixIcon={!isCTABusy ? ArrowNext : null}
          type="primary"
          disabled={!enableContinue}
          onClick={this.loginHandler}
          textProps={{ size: 14 }}
          containerStyle={styles.submitButton}
          testID={TEST_IDS.GET_OTP_BUTTON}
          accessibilityLabel={ACCESSIBILITY_LABEL.GET_OTP_BUTTON}
        >
          {isCTABusy ? <SLoader size={28} color="white" /> : null}
        </SButton>

        <WhatsAppComponent
          whatsappSubscribed={whatsappSubscribed}
          setSubscription={this.setSubscription}
          Current_Page="New loginRegistration"
          Page_Modal="Welcome - Signup"
        />
        <TermsAndConditions variant={variant} />
        <SModal visible={loaderVisible}>
          <View style={{ padding: 16 }}>
            <SLoader />
          </View>
        </SModal>
        <SSnackbar
          visible={snackbarVisible}
          text={snackbarText}
          backgroundColor={snackbarBackgroundColor}
          onCompletion={this.hideSnackbar}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  root: {
    minHeight: 250,
    height: "100%",
    backgroundColor: "transparent"
  },
  logo: {
    position: "absolute",
    width: 60,
    height: 20,
    zIndex: 10000,
    // top: 24,
    // left: 24
    ...Platform.select({
      web: {
        top: 24,
        left: 24
      },
      android: {
        top: 10,
        left: 10
      }
    })
  },
  loginBg: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  banner: {
    backgroundColor: "transparent",
    width: "100%",
    minHeight: 176
  },
  loginCurve: {
    width: "100%",
    height: "100%"
  },
  loginLogoContainer: {
    minHeight: 50,
    width: "100%",
    maxHeight: "50%"
  },
  loginBanner: {
    width: "100%",
    height: "100%",
    minHeight: 200,
    backgroundColor: "transparent"
  },
  avatarOne: {
    position: "absolute",
    width: 110,
    height: 140,
    ...Platform.select({
      web: {
        top: "35%",
        left: "5%"
      },
      android: {
        top: "20%",
        left: 5
      }
    })
    //top: "35%",
    //left: "5%"
  },
  avatarTwo: {
    position: "absolute",
    width: 145,
    height: 145,
    ...Platform.select({
      web: {
        left: "calc(50% - 74px)" //center- width/2
      },
      android: {
        left: "25%"
      }
    }),
    //left:"calc(50% - 68px)",
    top: "5%"
  },
  avatarThree: {
    position: "absolute",
    width: 232,
    height: 156,
    right: -25,
    //top:"50%",
    bottom: -10
  },
  tag: {
    position: "absolute",
    width: 96,
    height: 52,
    //top: "80%",
    bottom: 0,
    left: 16
  },
  welcomeTxtNormal: {
    fontWeight: "normal",
    color: "#000000"
  },
  welcomeTxt: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#000000",
    marginBottom: 20,
    paddingHorizontal: 8
  },
  welcomeTxtFree: {
    paddingHorizontal: 0,
    fontWeight: "bold"
  },
  inputLabel: {
    fontSize: 12,
    lineHeight: 16,
    color: Colors.Grey[1]
  },
  inputStyle: {
    paddingLeft: 4,
    fontSize: 18,
    textAlignVertical: "center"
  },
  containerStyle: {
    marginVertical: 0,
    width: "100%",
    paddingHorizontal: 16
  },
  submitButton: {
    marginTop: 10,
    marginHorizontal: 16,
    height: 48
  },
  termsAndConditionsStyle: {
    margin: 16,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    ...Platform.select({
      android: {
        marginBottom: 10
      }
    })
  }
});

export default withApollo(LoginSignUpComponent);
